export default {
    'transition': 'ease-in-out .15s',
    'max-text-width': '500px',
};



//////////////////
// WEBPACK FOOTER
// ./common/front-end-vars.js
// module id = OBpm
// module chunks = 1 2 3